if (!Object.hasOwn) {
    Object.defineProperty(Object, 'hasOwn', {
        configurable: true,
        enumerable: false,
        writable: true,
        value: function hasOwn(obj, prop) {
            return Object.prototype.hasOwnProperty.call(Object(obj), prop);
        }
    });
}
